export default __webpack_public_path__ + "static/naufelnaufel-236157a14c413fcd4757a84d57e6879c.png";